import { LessonControlMessage, LessonState } from '../helpers/constants';
import { LogPayload } from '../helpers/logger';
import { is } from '../helpers/type-utils';

export enum LessonControlTypes {
  LessonStateControl = 'LessonStateControl',
  LessonControl = 'LessonControl',
}

type ILessonStateControl = {
  lessonState: LessonState;
  type: LessonControlTypes.LessonStateControl;
};
type ILessonControl = {
  controlMessage: LessonControlMessage;
  monitor: string; // Only used when the control message is to UPDATE_DIALOG_MONITOR
  type: LessonControlTypes.LessonControl;
};

export type IControlMessage = ILessonStateControl | ILessonControl;

export type IKeyboardMessage = {
  key: string;
};

export type IFocusMessage = {
  windowId: string;
  widgetId: string;
};

export type IMonitorInitSync = {
  monitor: string;
  state: string;
};

export type IInputEventMessage = {
  name: string;
  parameters: any;
};

export type IExecutorActionMessage = {
  type: string;
  payload: any;
  actionFromExecutor: boolean;
};

export type IActionForMainMonitorMessage = IExecutorActionMessage;

export type ILogControlMessage =
  | {
      type: 'LogRequest';
    }
  | {
      type: 'LogResponse';
      payload: string;
    };

export const isLessonControlMessage = is<IControlMessage, ILessonControl>(
  (message) => {
    if (message.type === LessonControlTypes.LessonControl) {
      return message;
    }
  }
);

export const isLessonStateControlMessage = is<
  IControlMessage,
  ILessonStateControl
>((message) => {
  if (message.type === LessonControlTypes.LessonStateControl) {
    return message;
  }
});
